import axios from 'axios';

export const analyticsEndpoints = {
    updateAnalytics: '/api/reporting',
    updateSlideAnalytics: '/api/reporting/slides'
}

export const updateAnalytics = async ({ presentationId, events }) => {
    try {
        await axios.post(analyticsEndpoints.updateAnalytics, { events, presentationId });
    } catch (err) {
        console.error(err);
    }
};

export const updateSlideAnalytics = async ({ metricName, presentationId = null, slideId }) => {
    try {
        await axios.post(analyticsEndpoints.updateSlideAnalytics, { metricName, presentationId, slideId });
    } catch (err) {
        console.error(err);
    }
};
